import { render, staticRenderFns } from "./ProductServices.vue?vue&type=template&id=70a2b6a6&"
import script from "./ProductServices.vue?vue&type=script&lang=js&"
export * from "./ProductServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports